"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91727],{

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 27934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LivePriceSymbolsKeyEnum; }
/* harmony export */ });
var LivePriceSymbolsKeyEnum;
(function(LivePriceSymbolsKeyEnum) {
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_WATCHLIST"] = "sideWidgetWatchlist";
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    LivePriceSymbolsKeyEnum["COMPANY_HERO"] = "companyHero";
    LivePriceSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    LivePriceSymbolsKeyEnum["TRENDING_STOCK"] = "trendingStock";
    LivePriceSymbolsKeyEnum["CATALOG"] = "catalog";
    LivePriceSymbolsKeyEnum["SECTOR"] = "sector";
    LivePriceSymbolsKeyEnum["WATCHLIST"] = "watchlist";
    LivePriceSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    LivePriceSymbolsKeyEnum["IHSG_WIDGET"] = "ihsgWidget";
    LivePriceSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    LivePriceSymbolsKeyEnum["TRANSACTION_FORM"] = "transactionForm";
    LivePriceSymbolsKeyEnum["TRADE_PAGE"] = "tradePage";
    LivePriceSymbolsKeyEnum["PORTFOLIO_DETAIL"] = "portfolioDetail";
    LivePriceSymbolsKeyEnum["ORDERLIST_DETAIL"] = "orderlistDetail";
    LivePriceSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(LivePriceSymbolsKeyEnum || (LivePriceSymbolsKeyEnum = {}));


/***/ }),

/***/ 7538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XA": function() { return /* binding */ natsLivePriceFormatter; }
/* harmony export */ });
/* unused harmony exports oldLivePriceFormatter, isNatsLivePriceResponse */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var natsLivePriceFormatter = function(liveprice) {
    return {
        // orderbook col 1
        previous: liveprice.prev,
        change: liveprice.change.value,
        percentage_change: liveprice.change.percentage,
        frequency: liveprice.frequency,
        // orderbook col 2
        open: liveprice.open,
        high: liveprice.high,
        low: liveprice.low,
        // fbuy: 0, // Not Exist in LivePrice Nats
        // orderbook col 3
        volume: liveprice.volume,
        value: liveprice.value,
        average: liveprice.average,
        // fsell: 0, // Not Exist in LivePrice Nats
        // misc
        close: liveprice.close,
        lastprice: liveprice.lastprice,
        date: liveprice.date,
        stockCode: liveprice.stockCode
    };
};
var oldLivePriceFormatter = function(param) {
    var ohlc = param.ohlc, widget = param.widget, sym = param.sym;
    return {
        // orderbook col 1
        previous: ohlc.previous,
        change: widget[sym].price_change,
        percentage_change: widget[sym].percentage_change,
        frequency: ohlc.frequency,
        // orderbook col 2
        open: ohlc.Open,
        high: ohlc.High,
        low: ohlc.Low,
        fbuy: ohlc.foreign_buy,
        // orderbook col 3
        volume: ohlc.volume,
        value: ohlc.value,
        average: ohlc.avg_price,
        fsell: ohlc.foreign_sell,
        // misc
        close: ohlc.Close,
        lastprice: widget[sym].lastprice,
        date: ohlc.date_formated ? moment(ohlc.date_formated, "YYYY-MM-DD HH:mm:ss").format() : "",
        stockCode: sym
    };
};
/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ var isNatsLivePriceResponse = function(rawLivePrice) {
    return rawLivePrice.stockCode !== undefined;
}; // Formatted Nats
 // {
 //     "previous": 4710,
 //     "change": -10,
 //     "percentage_change": -0.21231422505307856,
 //     "frequency": 13409,
 //     "open": 4760,
 //     "high": 4770,
 //     "low": 4700,
 //     "volume": 89721000,
 //     "value": 424632501000,
 //     "average": 4733,
 //     "close": 4700,
 //     "lastprice": 4700,
 //     "date": "2023-03-15T15:09:29.728289+07:00",
 //     "stockCode": "BBRI"
 // }
 // Raw Nats
 // {
 //   "stockCode": "GOTO",
 //   "lastprice": 120,
 //   "volume": 2619794600,
 //   "high": 125,
 //   "low": 119,
 //   "open": 124,
 //   "frequency": 20846,
 //   "average": 122,
 //   "date": "2023-03-15T14:48:21.762801+07:00",
 //   "close": 120,
 //   "prev": 121,
 //   "value": 318585803700,
 //   "change": {
 //     "value": -1,
 //     "percentage": -0.8264462809917356
 //   },
 //   "orderVerb": "B",
 //   "quantity": "85200",
 //   "sequenceNumber": "3963134",
 //   "orderBookId": "4311",
 //   "orderNumber": "202303150001779420",
 //   "matchNumber": "202303150001127170",
 //   "board": "BOARD_TYPE_RG"
 // }
 // Raw Old
 // {
 //   "sym": "BBCA",
 //   "date_unix": 1678865974,
 //   "ohlc": {
 //     "Adj_Close": 8350,
 //     "Close": 8350,
 //     "High": 8475,
 //     "Low": 8325,
 //     "Open": 8450,
 //     "volume": 46148300,
 //     "date_unix": 1678865974,
 //     "date_formated": "2023-03-15 14:39:34",
 //     "dividend": 0,
 //     "foreign_buy": 0,
 //     "foreign_flow": 0,
 //     "foreign_sell": 0,
 //     "frequency": 14038,
 //     "marketcap": 0,
 //     "value": 387196490000,
 //     "shareoutstanding": 0,
 //     "ann_eps": 0,
 //     "ann_pe": 0,
 //     "avg_price": 8390,
 //     "previous": 8325,
 //     "freq_analyzer": 0
 //   },
 //   "widget": {
 //     "BBCA": {
 //       "lastprice": 8350,
 //       "price_change": 25,
 //       "percentage_change": 0.3003
 //     }
 //   },
 //   "OFFER-RG": {},
 //   "BID-RG": {},
 //   "__t": "1678865974"
 // }


/***/ }),

/***/ 35320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useLivePriceSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _liveprice_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66620);


var useLivePriceSender = function(key, symbols) {
    var setLivePriceSymbols = (0,_liveprice_store__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceStore */ .H)().setLivePriceSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var listSymbol = stringSymbols ? stringSymbols.split(",") : [];
        setLivePriceSymbols(key, listSymbol);
        return function() {
            return setLivePriceSymbols(key, []);
        };
    }, [
        key,
        stringSymbols,
        setLivePriceSymbols
    ]);
};


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 13 modules
var websocket_pb = __webpack_require__(84);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx


















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        (ref = socket.current) === null || ref === void 0 ? void 0 : ref.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 49696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedMessageEffect = function(channel, key, action) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (action) {
            setAction(channel, key, action);
            return function() {
                return removeAction(channel, key);
            };
        }
    }, [
        channel,
        key,
        action
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedMessageEffect);


/***/ })

}]);